import axios from "axios";

import base_url from "../constants/base_url";

axios.defaults.baseURL = base_url;

export default axios;
